module.exports = __webpack_public_path__ + "static/media/polish.c40832cb.svg";